export default __webpack_public_path__ + "static/media/checkpoint.63636c36.svg";